import React from 'react'
import InlineSVG from 'react-inlinesvg'

import { Document } from '../../../api/documents/types'
import MetadataLabel from './MetadataLabel'
import AuthorsLabel from './AuthorsLabel'
import ContentTag from './ContentTag'
import OpenDocumentButton from './OpenDocumentButton'
import * as dateLib from '../../../libraries/date'
import { useI18N } from '../../../libraries/i18n/hook'
import PdfViewer from '../pdf'
import PageHeading from '../layout/PageHeading'
import BookmarkButton from './BookmarkButton'
import DescriptionText from './DescriptionText'
import ShareButton from '../form/ShareButton'
import MoreActionsButton from '../form/MoreActionsButton'

interface Props extends Document {
  handleToggleBookmark: () => void
}
const DocumentDetails:React.FC<Props> = ({ id, title, details, type, readTime, createdAt, mainCategory, difficultyLevel, authors, href, srcUrl, userActivity, handleToggleBookmark }) => {
  const { t } = useI18N()
  return (
    <div>
      <PageHeading>{title}</PageHeading>
      <DescriptionText>{details}</DescriptionText>
      <div className='w-full m-auto mt-8 sm:mt-0 text-sm bg-soft-green md:bg-transparent px-4 p-2 md:p-0 rounded-md'>
        <div className='sm:mt-10 flex flex-col-reverse md:flex-row md:flex justify-between'>
          <div className='flex flex-col-reverse mt-4 md:mt-0 block md:flex-row md:items-center gap-x-6'>
            <div className='flex flex-wrap gap-4 mb-2 md:mb-0'>
              <div className='flex items-center text-xs gap-x-1 text-2xs sm:text-xs'>
                <InlineSVG src={type.icon} className='stroke-deep-green' />{type.name}
              </div>
              <MetadataLabel icon='clock' strokeColor='deep-green'><div className='text-2xs sm:text-xs'>{dateLib.parseSecondsToHoursAndMinutes(readTime)} {t('documents.read')}</div></MetadataLabel>
              <MetadataLabel icon='calendar' strokeColor='deep-green'><div className='text-2xs sm:text-xs'>{dateLib.parseToShortDate(createdAt)}</div></MetadataLabel>
            </div>
          </div>
          <div className='flex items-center gap-x-4'>
            <ContentTag label={mainCategory.name} bgColor='white' textColor='deep-green' />
            <ContentTag label={difficultyLevel.name} bgColor='deep-green' />
            <div className='hidden sm:inline-block'><BookmarkButton bookmarked={userActivity?.saved} onClick={handleToggleBookmark} /></div>
            <div className='hidden sm:inline-block'><ShareButton title={title} /></div>
            <div className='ml-auto inline-block sm:hidden'>
              <MoreActionsButton
                items={[
                  { id: 'bookmark', item: <BookmarkButton bookmarked={userActivity?.saved} onClick={handleToggleBookmark}>{userActivity?.saved ? t('content.bookmarked.remove') : t('content.bookmarked.add')}</BookmarkButton> },
                  { id: 'share', item: <ShareButton title={title} size='md' /> }
                ]}
              />
            </div>
          </div>
        </div>
        <AuthorsLabel authors={authors} strokeColor='deep-green' />
      </div>
      {href && <div data-testid='open-external-link' className='mt-8 text-center'><OpenDocumentButton href={href} /></div>}
      {!href && <div data-testid='pdf-reader'>
        <PdfViewer pdfFile={srcUrl} />
        <div className='sm:hidden text-center mt-6'>
          <OpenDocumentButton id={id} />
        </div>
      </div>}
    </div>
  )
}

export default DocumentDetails
